"use client"

import { useRouter, usePathname } from "next/navigation"

const NotFound = (): null => {
  const pathName = usePathname()
  const { replace } = useRouter()
  const isOldSignup = pathName.includes("/signup/") && pathName.split("/").length > 3

  if (isOldSignup) {
    replace(`/signup/cohort/?cohort=${pathName.split("/")[2]}`)
  } else {
    replace("/")
  }
  return null
}

export default NotFound
